import { render } from "./DataVis.vue?vue&type=template&id=ff2fe31c&scoped=true"
import script from "./DataVis.vue?vue&type=script&lang=js"
export * from "./DataVis.vue?vue&type=script&lang=js"

import "./DataVis.vue?vue&type=style&index=0&id=ff2fe31c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2fe31c"]])

export default __exports__